// Group by time only: these sections describe working hours, not bookable slots.
// Keep original events intact so detail actions retain their source and ownership.
export function buildDayAgenda(items) {
  const ordered = [...items].sort((a, b) => +new Date(a.start) - +new Date(b.start));
  const groups = [];
  ordered.filter(event => event.extendedProps.kind === "availability").forEach(event => {
    const start = +new Date(event.start);
    const end = +new Date(event.end);
    const previous = groups[groups.length - 1];
    if (previous && start <= previous.end) {
      previous.end = Math.max(previous.end, end);
      previous.hours.push(event);
    } else groups.push({ id: event.id, start, end, hours: [event], events: [] });
  });
  const outside = [];
  ordered.filter(event => event.extendedProps.kind !== "availability").forEach(event => {
    const start = +new Date(event.start);
    const end = +new Date(event.end);
    const group = groups.find(value => start >= value.start && start < value.end);
    if (group) group.events.push({ event, note: end > group.end ? "Extends beyond working hours" : "" });
    else outside.push({ id: event.id, start, events: [{ event, note: groups.some(value => start < value.end && end > value.start) ? "Starts outside working hours" : "Outside working hours" }] });
  });
  return [...groups, ...outside].sort((a, b) => a.start - b.start);
}
